module.exports = __webpack_public_path__ + "img/loading.69e7e390.gif";